<ngx-spinner color="#cd0005"></ngx-spinner>

<div id="register-view" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div class="flex items-center gap-1 mb-8">
    <i class="ri-user-add-line ri-xl"></i>
    <h1 class="text-3xl font-semibold text-gray-900">Register</h1>
  </div>

  <div class="bg-white rounded-lg shadow border border-gray-100">
    <div class="p-8">
      <div class="max-w-3xl">
        <form class="space-y-6" [formGroup]="accountForm">
          <div class="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Email Contact
                <span class="text-primary">*</span>
              </label>
              <input
                type="text"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="e.g. no-reply@airgateway.com"
                formControlName="email"
                error
                (blur)="onEmailBlur($event)"
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Username
                <span class="text-primary">*</span>
              </label>
              <input
                type="text"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="Inferred from email"
                formControlName="username"
                error
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Agency ID
                <span class="text-primary">*</span>
              </label>
              <input
                type="text"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2 disabled:bg-gray-100"
                placeholder="Inferred from email"
                formControlName="agency"
                error
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Company Name
                <span class="text-primary">*</span>
              </label>
              <input
                type="text"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="e.g. AirGateway GmbH"
                formControlName="company_name"
                error
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Agency Address
                <span class="text-primary">*</span>
              </label>
              <input
                type="tel"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="e.g. Gutzkowstr. 8"
                formControlName="address"
                error
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Country
                <span class="text-primary">*</span>
              </label>
              <select
                formControlName="country_code"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2 text-gray-900 invalid:text-gray-400"
                error
              >
                <option value="" disabled selected>Select country</option>
                <option *ngFor="let c of countries | keyvalue" [value]="c.key">
                  {{ c.value }}
                </option>
              </select>
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Zip Code
                <span class="text-primary">*</span>
              </label>
              <input
                type="tel"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="e.g. 10827"
                formControlName="postal_code"
                error
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">
                Phone Number
                <span class="text-primary">*</span>
              </label>
              <input
                type="tel"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="e.g. +491570000000"
                formControlName="phone"
                error
              />
            </div>
            <div>
              <label class="block text-[1.1rem] font-bold text-gray-700">IATA/TIDS code</label>
              <input
                type="tel"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-base px-3 py-2"
                placeholder="e.g. 27305429"
                formControlName="iata_number"
                error
              />
            </div>
          </div>
          <div class="flex justify-end">
            <button (click)="saveChanges()" type="submit" class="btn btn-primary text-base">
              Create new account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
